<template>
  <div>
    <Main
      :tableData="tableData"
      :loading="loading"
      :disabled="disabled"
      @reload="getData"
      @openEditDialog="openEditDialog"
    >
      <template #header>
        <div class="d-flex mt-2">
          <div class="side-frame"></div>
          <div>
            <span style="font-size: 14px; color: #606266">
              {{ $l('table_title_vehicle') || '运输车辆信息' }}
            </span>
            <el-divider direction="vertical" v-if="!disabled" />
            <b-button
              v-if="!disabled"
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="openEditDialog()"
            >
              {{ $l('btn_addVehicle') || '增加运输车辆' }}
            </b-button>
          </div>
        </div>
      </template>
    </Main>

    <EditVehicle
      :visible.sync="edidOptions.visible"
      :hxJdVehicleCode="edidOptions.hxJdVehicleCode"
      :hxShipmentJdCode="hxShipmentJdCode"
      @reload="getData"
    />
  </div>
</template>
<script>
import Main from './main.vue'
import EditVehicle from '../edit-vehicle'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  components: { Main, EditVehicle },
  props: {
    disabled: { type: Boolean, default: false },
    hxShipmentJdCode: { type: String, default: '' },
  },
  data() {
    return {
      tableData: [],
      loading: false,
      edidOptions: { visible: false, hxJdVehicleCode: '' },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      this.loading = true
      const res = await this.$api
        .ecomHxShipmentJdVehicleListApi({
          hxShipmentJdCode: this.hxShipmentJdCode,
        })
        .catch(() => null)
      this.loading = false
      if (!res) return
      this.tableData = res.body?.data
    },
    openEditDialog({ hxJdVehicleCode } = {}) {
      this.edidOptions = { visible: true, hxJdVehicleCode }
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 5px;
  border-left: 3px solid $color-primary;
  height: 20px;
  margin-top: 3px;
}
</style>
